import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNews = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.42243 15.0833C2.00149 15.0833 1.64518 14.9375 1.35352 14.6458C1.06185 14.3541 0.916016 13.9978 0.916016 13.5769V2.4231C0.916016 2.00216 1.06185 1.64585 1.35352 1.35419C1.64518 1.06252 2.00149 0.916687 2.42243 0.916687H11.1564L15.0826 4.84296V13.5769C15.0826 13.9978 14.9368 14.3541 14.6451 14.6458C14.3535 14.9375 13.9972 15.0833 13.5762 15.0833H2.42243ZM4.04102 11.75H11.9576V10.5H4.04102V11.75ZM4.04102 8.62498H11.9576V7.37502H4.04102V8.62498ZM10.4993 5.5H13.8327L10.4993 2.16667V5.5ZM4.04102 5.5H7.99933V4.25002H4.04102V5.5Z",
		fill: "#1B1B1B"
	})
});
export default SvgNews;
